import React, { Component } from 'react';
import { isNull, mapValues } from 'lodash';
import { message } from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import helpers from 'utils/helpers';
import { BoxDrawer, BigInputNumber, StyledButton } from 'components/Styled';
import InfoBar from 'components/common/InfoBar';

class CustomBoxDrawer extends Component {
  state = {
    length: null,
    width: null,
    height: null
  };

  handleLengthChange = value => {
    this.setState({
      length: value
    });
  };

  handleWidthChange = value => {
    this.setState({
      width: value
    });
  };

  handleHeightChange = value => {
    this.setState({
      height: value
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const length = isNull(this.state.length)
      ? this.props.boxSize.length
      : this.state.length;
    const width = isNull(this.state.width)
      ? this.props.boxSize.width
      : this.state.width;
    const height = isNull(this.state.height)
      ? this.props.boxSize.height
      : this.state.height;

    if (length && width && height) {
      if (
        (length * width * height) / 5000 > 2 &&
        this.props.boxType === 'smallBox'
      ) {
        message.warning(this.props.t('quotation.small_parcel_too_large'));

        this.props.onSubmit({
          boxType: 'largeBox',
          boxSize: { length, width, height },
          index: this.props.index
        });
      } else {
        this.props.onSubmit({
          boxType: this.props.boxType,
          boxSize: { length, width, height },
          index: this.props.index
        });
      }
    } else {
      helpers.message.error(
        this.props.t('quotation.err_msg.invalid_input'),
        'quotation'
      );
    }
  };

  render() {
    return (
      <div>
        <BoxDrawer
          placement="left"
          onClose={this.props.onClose}
          visible={this.props.visible}
          closable={true}
          width={'100%'}
          key={this.props.drawerKey}>
          <div
            style={{
              width: '100%',
              textAlign: 'center'
            }}>
            <form onSubmit={this.handleSubmit}>
              <div
                className="buttonTheme-color"
                style={{
                  color: '#57D7DD',
                  fontWeight: 700,
                  fontSize: '24px'
                }}>
                {`${this.props.t('quotation.input')}${this.props.t(
                  `quotation.parcel_form.boxes.${this.props.boxType}`
                )}${this.props.t('quotation.size')}`}
              </div>
              <div
                style={{
                  fontSize: '12px'
                }}>
                {this.props.t('quotation.drawer_description')}
                <span
                  className="buttonSecond-color"
                  style={{
                    color: '#57D7DD',
                    paddingLeft: '3px',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    this.props.openStaticPopup(
                      this.props.getVolumeWeightPopup()
                    );
                  }}>
                  <FontAwesomeIcon icon="question-circle" />
                </span>
              </div>
              <div
                style={{
                  padding: '40px 0'
                }}>
                <img
                  src={this.props.boxImage}
                  style={mapValues(
                    this.props.boxImageStyle,
                    x => `${parseFloat(x) * 3}px`
                  )}
                  alt=""
                />
              </div>
              <div>
                <div
                  style={{
                    display: 'inline-block',
                    textAlign: 'right'
                  }}>
                  <BigInputNumber
                    min={0}
                    max={302}
                    defaultValue={this.props.boxSize.length || null}
                    onChange={this.handleLengthChange}
                    precision={0}
                    inputMode="decimal"
                    placeholder="0"
                  />
                  <span style={{ fontWeight: 700 }}>×</span>
                  <BigInputNumber
                    min={0}
                    max={203}
                    defaultValue={this.props.boxSize.width || null}
                    onChange={this.handleWidthChange}
                    precision={0}
                    inputMode="decimal"
                    placeholder="0"
                  />
                  <span style={{ fontWeight: 700 }}>×</span>
                  <BigInputNumber
                    min={0}
                    max={178}
                    defaultValue={this.props.boxSize.height || null}
                    onChange={this.handleHeightChange}
                    precision={0}
                    inputMode="decimal"
                    placeholder="0"
                  />
                  <br />
                  <span
                    style={{
                      paddingRight: '10px',
                      color: '#2C2C2E',
                      fontWeight: 700,
                      lineHeight: 2
                    }}>
                    cm
                  </span>
                </div>
              </div>
              <div style={{ margin: '10px -15px 0', textAlign: 'left' }}>
                <InfoBar
                  title={{
                    __html: this.props.t('quotation.info_title')
                  }}
                  content={{
                    __html: this.props.t('quotation.info_contents')
                  }}
                  t={this.props.t}
                />
              </div>
              <div style={{ paddingTop: '30px' }}>
                <StyledButton
                  ghost
                  type="primary"
                  width={165}
                  htmlType="submit">
                  {this.props.t('button.confirm')}
                </StyledButton>
              </div>
            </form>
          </div>
        </BoxDrawer>
      </div>
    );
  }
}

export default CustomBoxDrawer;
